import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.isAnimating = false
    this.aborted = false
    this.stopOnInteraction = this.stopOnInteraction.bind(this)

    this.element.addEventListener('pointerdown', this.stopOnInteraction, { once: true })
    this.element.addEventListener('focusin', this.stopOnInteraction, { once: true })

    this.scheduleStart()
  }

  disconnect() {
    this.aborted = true
    this.isAnimating = false
    this.element.removeEventListener('pointerdown', this.stopOnInteraction)
    this.element.removeEventListener('focusin', this.stopOnInteraction)
    if (this.currentResolve) {
      this.currentResolve()
      this.currentResolve = null
    }
  }

  stopOnInteraction() {
    this.aborted = true
    this.isAnimating = false
    if (this.currentResolve) {
      this.currentResolve()
      this.currentResolve = null
    }
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.currentResolve = resolve
      const start = performance.now()
      const check = () => {
        if (this.aborted || !this.isAnimating) {
          resolve()
          return
        }
        if (performance.now() - start >= ms) {
          this.currentResolve = null
          resolve()
          return
        }
        requestAnimationFrame(check)
      }
      requestAnimationFrame(check)
    })
  }

  scheduleStart() {
    const observer = new MutationObserver(() => {
      if (this.numberField()) {
        observer.disconnect()
        this.startAnimation()
      }
    })
    observer.observe(this.element, { childList: true, subtree: true })

    if (this.numberField()) {
      observer.disconnect()
      this.startAnimation()
    }
  }

  numberField() {
    return this.element.querySelector('[data-dialer-target="numberField"]')
  }

  numpadButton(digit) {
    return this.element.querySelector(`[data-action*="dialer#input"][data-number="${digit}"]`)
  }

  async startAnimation() {
    this.isAnimating = true
    await this.wait(1500)

    while (this.isAnimating && !this.aborted) {
      await this.typeNumber('4155550142')
      if (this.aborted) break

      await this.wait(3000)
      if (this.aborted) break

      this.clearNumber()
      await this.wait(1500)
    }
  }

  async typeNumber(digits) {
    const field = this.numberField()
    if (!field) return

    for (const digit of digits) {
      if (this.aborted) return

      const button = this.numpadButton(digit)
      if (button) {
        button.classList.add('bg-primary/20')
        button.classList.remove('bg-raised')
      }

      field.value = (field.value || '') + digit

      await this.wait(150 + Math.random() * 200)
      if (this.aborted) return

      if (button) {
        button.classList.remove('bg-primary/20')
        button.classList.add('bg-raised')
      }

      if (field.value.length > 5) {
        field.dispatchEvent(new Event('change'))
      }
    }
  }

  clearNumber() {
    const field = this.numberField()
    if (field) {
      field.value = ''
      field.dispatchEvent(new Event('change'))
    }

    const rateEl = this.element.querySelector('[data-dialer-target="rateAmount"]')
    if (rateEl) {
      rateEl.textContent = '$\u2014 / min'
    }
  }
}
